// extracted by mini-css-extract-plugin
module.exports = {"priceFrom":"Product_priceFrom__1ex0p","labelPriceContainer":"Product_labelPriceContainer__1WwXd","labelContainer":"Product_labelContainer__2MNpC"};